<template>
    <div class="transport-conditions-component text-none pa-4 pa-md-8 mb-16">
        <div class="main-header text-center mb-10 pt-10" v-html="$t('transport_conditions.main_header')"></div>
        <ol class="text-left text ml-4 mb-6">
            <li class="mb-4 first" v-html="$t('transport_conditions.general_provision.p_1')"></li>
            <li class="mb-4 first" v-html="$t('transport_conditions.general_provision.p_2')"></li>
            <li class="mb-4 first" v-html="$t('transport_conditions.general_provision.p_3')"></li>
            <li class="mb-4 first" v-html="$t('transport_conditions.general_provision.p_4')"></li>
            <li class="mb-4 first" v-html="$t('transport_conditions.general_provision.p_5')"></li>
            <li class="mb-4 first" v-html="$t('transport_conditions.general_provision.p_6')"></li>
            <li class="mb-4 first" v-html="$t('transport_conditions.general_provision.p_7')"></li>
            <li class="mb-4 first" v-html="$t('transport_conditions.general_provision.p_8')"></li>
            <li class="mb-4 first" v-html="$t('transport_conditions.general_provision.p_9')"></li>
        </ol>

    </div>
</template>

<script>
export default {
    name: "transport-conditions-component"
}
</script>

<style lang="scss" scoped>
.transport-conditions-component {
    background: white;
}

.main-header {
    @include nsb-gentium-bold;
    font-size: 28px;
    line-height: 32px;
}

.header {
    @include nsb-gentium-bold;
    font-size: 18px;
    line-height: 24px;
}

.text {
    @include nsb-font-container;
    font-size: 14px;
    line-height: 24px;
}

.emphasis {
    margin-top: 4px;
    margin-bottom: 4px;
}

.link {
    text-decoration: underline !important;
    font-weight: bold;
    cursor: pointer;
}

li.first {
    position: relative;
    padding-left: 5px;
}

li.second {
    position: relative;
    margin-left: 20px;
    padding-left: 5px;
}

li.bracket:before {
    content: ") ";
    counter-increment: list;
}

li:before {
    position: absolute;
    left: -5px;
}

.table-wrapper {
    overflow-x: auto;
    border: 1px solid $ds-primary;

    td {
        width: 25%;
        padding: 8px;
        border-color: $ds-primary;
        color: $ds-primary;

        &.first {
            border-bottom: 2px solid $ds-primary;
        }
    }

    table {
        width: 100%;
        min-width: 600px;
        border-collapse: collapse;
    }
}

@media (min-width: 960px) {
    .transport-conditions-component {
        background: white;
    }

    li.first {
        position: relative;
        padding-left: 10px;
    }

    li.second {
        position: relative;
        margin-left: 40px;
        padding-left: 10px;
    }

    li.bracket:before {
        content: ") ";
        counter-increment: list;
    }

    li:before {
        position: absolute;
        left: -5px;
    }
}
</style>